import { render, staticRenderFns } from "./marketDynamicAndPriceInfoList.vue?vue&type=template&id=1f20247a&scoped=true"
import script from "./marketDynamicAndPriceInfoList.vue?vue&type=script&lang=js"
export * from "./marketDynamicAndPriceInfoList.vue?vue&type=script&lang=js"
import style0 from "./marketDynamicAndPriceInfoList.vue?vue&type=style&index=0&id=1f20247a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f20247a",
  null
  
)

export default component.exports